module.exports = __webpack_public_path__ + "static/media/Toren_SemiClose_2.e766bc81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/04/03/assets/Toren_SemiClose_2.jpg
// module id = 542
// module chunks = 0